import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';

import Datebar from 'components/filters/Datebar/Datebar';
import FilterSidebar from 'components/filters/FilterSidebar/FilterSidebar';
import SidebarLayout from 'components/layouts/SidebarLayout/SidebarLayout';
import { openModal } from 'actions/modalActions';
import { getLastUnratedAppointment } from 'actions/ratingActions';
import { getTrialCoupon } from 'actions/userActions';

class ScheduleLesson extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingUnratedLesson: false,
    };
  }

  componentDidMount() {
    this.showRateLastLesson(this.props.user);
  }

  componentWillReceiveProps(nextProps) {
    // On user login
    if (nextProps.user.id && nextProps.user.id !== this.props.user.id) {
      this.showRateLastLesson(nextProps.user);
    }

    // On user logout, allow the unrated lesson popup to show up again
    if (!nextProps.user.id && this.state.loadingUnratedLesson) {
      this.setState({ loadingUnratedLesson: false });
    }
  }

  offerTrialUpgrade(appointment) {
    const { trialStatus } = this.props.user;
    if (!trialStatus) return;

    if (trialStatus.status === 'credit_trial') {
      this.props.getTrialCoupon((coupon) => {
        setTimeout(() => {
          this.props.openModal('trial-upgrade-modal', { coupon, trialStatus, appointment });
        }, 1500);
      });
    }
  }

  showRateLastLesson(user) {
    if (this.state.loadingUnratedLesson === true) return;
    if (!user.id) return;
    this.setState({ loadingUnratedLesson: true });
    this.props.getLastUnratedAppointment((appointment) => {
      // Since this modal can show right after the login modal disappears,
      // we need a delay or there can be interference. Otherwise, the modal
      // appears but completely disabled. 500ms worked locally so doing double
      // (1s) to be safe.
      setTimeout(() => {
        this.props.openModal('confirm-lesson-modal', {
          trialStatus: this.props.user.trialStatus,
          appointment,
          onSkipRating: () => {
            this.offerTrialUpgrade(appointment);
          },
          onRatingComplete: () => {
            this.offerTrialUpgrade(appointment);
          },
        });
      }, 1000);
    });
  }

  render() {
    return (
      <div className="ScheduleLesson">
        <div className="row">
          <Datebar />
        </div>

        <SidebarLayout
          sidebarComponent={<FilterSidebar />}
          children={this.props.children}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { user: state.user.profile, token: state.user.token };
}

export default connect(mapStateToProps, {
  openModal,
  getLastUnratedAppointment,
  getTrialCoupon,
})(ScheduleLesson);



// WEBPACK FOOTER //
// ./src/pages/student/ScheduleLesson/index.js